import { ref } from "vue"

// Module-level singleton state so any I2Label caller and the app-level host
// (frame.vue) share the same editor instances. The composable only manages
// open/close state for the field-level help editors; the help content cache
// lives in helpLabelStore.

const tooltipEditorVisible = ref(false)
const helpTextEditorVisible = ref(false)
const helpTextReadonly = ref(false)
const activeHelpElementName = ref("")
const activeLabel = ref("")

export function useHelpEditor() {
	// Open the tooltip editor dialog for a given label key.
	function openTooltipEditor(helpElementName: string, label: string): void {
		activeHelpElementName.value = helpElementName
		activeLabel.value = label
		tooltipEditorVisible.value = true
	}

	// Open the help text editor drawer in edit mode.
	function openHelpTextEditor(helpElementName: string, label: string): void {
		activeHelpElementName.value = helpElementName
		activeLabel.value = label
		helpTextReadonly.value = false
		helpTextEditorVisible.value = true
	}

	// Open the help text drawer in read-only view mode (info icon click).
	function openHelpViewer(helpElementName: string, label: string): void {
		activeHelpElementName.value = helpElementName
		activeLabel.value = label
		helpTextReadonly.value = true
		helpTextEditorVisible.value = true
	}

	return {
		tooltipEditorVisible,
		helpTextEditorVisible,
		helpTextReadonly,
		activeHelpElementName,
		activeLabel,
		openTooltipEditor,
		openHelpTextEditor,
		openHelpViewer,
	}
}
